/**
 *
 * GoBackButton
 *
 */

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// antd component
import { Button } from 'antd';

import ErrorBoundary from 'engine/ErrorBoundary';

// icons
import CustomIcons from 'components/CustomIcons';

function GoBackButton({
  buttonName,
  // actions
  onGoBack,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('go-back-button', className);
  const { t } = useTranslation();

  const onGoBackHandler = useCallback(() => {
    if (!!onGoBack) {
      onGoBack();
    } else {
      window.history.back();
    }
  }, [onGoBack]);

  return (
    <ErrorBoundary>
      <Button className={childClassNames} onClick={onGoBackHandler}>
        <CustomIcons type="arrow-left" />
        {!!buttonName && buttonName || t("common.backTo")}
      </Button>
    </ErrorBoundary>
  );
}

GoBackButton.defaultProps = {};
GoBackButton.propTypes = {
  onGoBack: PropTypes.func,
};

export default GoBackButton;
